import React, { useEffect, useState } from "react";
import { fxApi } from "../../lib/ledgerApi";
import { Globe2, RefreshCw, Activity } from "lucide-react";

const fmt = (s, d = 6) => {
  try { const n = Number(s); if (Number.isFinite(n)) return n.toLocaleString(undefined, { maximumFractionDigits: d }); } catch {}
  return s;
};

export default function FX() {
  const [snap, setSnap] = useState(null);

  const load = async () => {
    try { setSnap(await fxApi.rates()); } catch {}
  };
  useEffect(() => { load(); const i = setInterval(load, 15000); return () => clearInterval(i); }, []);

  return (
    <div className="max-w-5xl px-6 md:px-10 py-10 md:py-14">
      <div className="mb-8 flex items-end justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">/ FX</div>
          <h1 className="text-3xl sm:text-4xl tracking-tight font-medium flex items-center gap-3">
            <Globe2 className="w-6 h-6 text-muted-foreground" strokeWidth={1.5} />
            Foreign exchange
          </h1>
          <p className="mt-3 text-sm text-muted-foreground max-w-xl">
            All cross-currency transfers route source → NEO → target. Rates from
            <code className="font-mono mx-1">open.er-api.com</code> base USD, refreshed every ~4 minutes.
          </p>
        </div>
        {snap && (
          <div className="text-xs font-mono text-muted-foreground text-right">
            <div>updated {new Date(snap.fetched_at).toLocaleString()}</div>
            <div className={snap.stale ? "text-status-tampered" : "text-status-ok"}>
              {snap.stale ? "stale" : "live"}
            </div>
          </div>
        )}
      </div>

      <div className="border border-border rounded-sm bg-card overflow-hidden" data-testid="fx-rates-table">
        <div className="grid grid-cols-12 px-4 py-3 text-[10px] uppercase tracking-[0.2em] text-muted-foreground border-b border-border bg-muted/30">
          <div className="col-span-3">Currency</div>
          <div className="col-span-3 text-right">Per 1 USD</div>
          <div className="col-span-3 text-right">Per 1 of currency (USD)</div>
          <div className="col-span-3 text-right">Override</div>
        </div>
        {snap && Object.entries(snap.rates).map(([c, r]) => {
          const ovr = snap.overrides?.find((o) => o.currency === c);
          const num = Number(r);
          return (
            <div key={c} data-testid={`fx-row-${c}`} className="grid grid-cols-12 px-4 py-3 border-b border-border last:border-b-0 items-center font-mono text-sm">
              <div className="col-span-3 font-medium">{c}</div>
              <div className="col-span-3 text-right">{fmt(num, 6)}</div>
              <div className="col-span-3 text-right">{Number.isFinite(num) && num > 0 ? fmt(1 / num, 6) : "—"}</div>
              <div className="col-span-3 text-right text-[11px]">
                {ovr ? <span className="text-status-info">manual · {ovr.set_by}</span> : <span className="text-muted-foreground">—</span>}
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 text-[11px] text-muted-foreground">
        <span className="inline-flex items-center gap-1"><Activity className="w-3 h-3" strokeWidth={1.5}/> rates poll every 15s</span>
      </div>
    </div>
  );
}
